import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issueTypeFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestTypeFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	typeFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypeGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestTypeGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unassignedRequestTypeGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	serviceRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	postIncidentReviewRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	developerEscalationRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	problemRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeRequestGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noRequestTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypeHelpText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypeFieldLabelIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypeGroupLabelIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addIssueTypeButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addWorkTypeButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editIssueTypeButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editWorkTypeButtonTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manageIssueTypesButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manageWorkTypesButtonTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editWorkTypeButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSearchResultsOldTerm: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSearchResultsIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issueTypeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-field-label',
		defaultMessage: 'Issue type',
		description: 'Label for issue type field in issue create form',
	},
	requestTypeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.request-type-field-label',
		defaultMessage: 'Request type',
		description: 'Label for request type field in issue create form',
	},
	typeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.type-field-label',
		defaultMessage: 'Type',
		description: 'Label for issue type field in issue create form',
	},
	issueTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-group-label',
		defaultMessage: 'Issue types',
		description: 'Label for issue types group in type field',
	},
	requestTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.request-type-group-label',
		defaultMessage: 'Request types',
		description: 'Label for request types group in type field',
	},
	unassignedRequestTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.unassigned-request-type-group-label',
		defaultMessage: 'Unassigned',
		description:
			'Label for unassigned request types group in type field (It contains request types that are not assigned to any ITSM category)',
	},
	serviceRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.service-request-group-label',
		defaultMessage: 'Service requests',
		description: 'Label for services requests group in type field',
	},
	incidentRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.incident-request-group-label',
		defaultMessage: 'Incidents',
		description: 'Label for incident requests group in type field',
	},
	postIncidentReviewRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.post-incident-review-request-group-label',
		defaultMessage: 'Post-incident reviews',
		description: 'Label for post-incident reviews requests group in type field',
	},
	developerEscalationRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.developer-escalation-request-group-label',
		defaultMessage: 'Developer escalations',
		description: 'Label for developer escalations reviews requests group in type field',
	},
	problemRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.problem-request-group-label',
		defaultMessage: 'Problems',
		description: 'Label for problem requests group in type field',
	},
	changeRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.change-request-group-label',
		defaultMessage: 'Changes',
		description: 'Label for change requests group in type field',
	},
	noRequestTypeLabel: {
		id: 'issue-create.modal.create-form.type-picker.no-request-type-label',
		defaultMessage: 'No request type',
		description: 'Label for picking no request type in the request type field in issue create form',
	},
	issueTypeHelpText: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-help-text',
		defaultMessage: 'Learn more',
		description: 'Help text for issue type field',
	},
	issueTypeFieldLabelIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-field-label-issue-term-refresh',
		defaultMessage: 'Work type',
		description: 'Label for issue type field in issue create form',
	},
	issueTypeGroupLabelIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-group-label-issue-term-refresh',
		defaultMessage: 'Work types',
		description: 'Label for issue types group in type field',
	},
	addIssueTypeButtonText: {
		id: 'issue-create.modal.create-form.type-picker.add-issue-type-button-text',
		defaultMessage: 'Add issue type',
		description: 'Label for add issue type button',
	},
	addWorkTypeButtonText: {
		id: 'issue-create.modal.create-form.type-picker.add-work-type-button-text',
		defaultMessage: 'Add work type',
		description: 'Label for add work type button',
	},
	editIssueTypeButtonText: {
		id: 'issue-create.modal.create-form.type-picker.edit-issue-type-button-text',
		defaultMessage: 'Edit issue type',
		description: 'Label for edit issue type button',
	},
	editWorkTypeButtonTextIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.edit-issue-type-button-text-issue-term-refresh',
		defaultMessage: 'Edit work type',
		description: 'Label for edit work type button',
	},
	manageIssueTypesButtonText: {
		id: 'issue-create.modal.create-form.type-picker.manage-issue-types-button-text',
		defaultMessage: 'Manage issue types',
		description: 'Label for manage issue types button',
	},
	manageWorkTypesButtonTextIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.manage-work-types-button-text-issue-term-refresh',
		defaultMessage: 'Manage work types',
		description: 'Label for manage work types button',
	},
	editWorkTypeButtonText: {
		id: 'issue-create.modal.create-form.type-picker.edit-work-type-button-text',
		defaultMessage: 'Edit type',
		description:
			'This is the tooltip text for edit button to inline edit a Work type from Work type dropdown list.',
	},
	noSearchResultsOldTerm: {
		id: 'issue-create.modal.create-form.type-picker.no-search-results-old-term',
		defaultMessage:
			"It looks like we can't find any issue types that match. <button>Create issue type</button>",
		description:
			'Message shown when user has typed to filter in issue type select and there are no matching results.',
	},
	noSearchResultsIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.no-search-results',
		defaultMessage:
			"It looks like we can't find any work types that match. <button>Create work type</button>",
		description:
			'Message shown when user has typed to filter in work type select and there are no matching results.',
	},
});
export default messages;
